module.exports = __webpack_public_path__ + "media/like.3344065c.mp3";